import React from "react";

export default function Tripod({ className }) {
  return (
    <>
      <svg
        className={className.artist1}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
      >
        <g id="a" />
        <g id="b" />
        <g id="c" />
        <g id="d" />
        <g id="e" />
        <g id="f" />
        <g id="g" />
        <g id="h" />
        <g id="i" />
        <g id="j" />
        <g id="k" />
        <g id="l">
          <g>
            <path d="M40,9h-7v-3h6c.553,0,1-.448,1-1V1c0-.552-.447-1-1-1h-14c-.553,0-1,.448-1,1V5c0,.552,.447,1,1,1h6v3h-7v2h16v-2ZM26,2h12v2h-12V2Z" />
            <path d="M60.599,57.553l-1.5-2.599c.478-.277,.642-.887,.366-1.366l-2.5-4.33c.479-.276,.643-.888,.366-1.366l-4-6.928c-.133-.229-.352-.397-.607-.466-.256-.069-.529-.033-.759,.1l-.859,.496-11.971-21.12c.486-.068,.866-.468,.866-.973v-6c0-.552-.447-1-1-1h-14c-.553,0-1,.448-1,1v2.279l-4.668,1.556-.384-1.151c-.086-.259-.274-.471-.521-.588-.245-.115-.529-.126-.786-.029l-13,5c-.499,.192-.759,.743-.589,1.25l1,3c.086,.259,.274,.471,.521,.588,.135,.063,.28,.096,.427,.096,.121,0,.243-.022,.359-.066l13-5c.482-.186,.732-.705,.596-1.198l4.045-1.348v1.612c0,.505,.38,.905,.866,.973l-11.971,21.12-.859-.496c-.23-.133-.504-.168-.759-.1-.256,.068-.475,.236-.607,.466l-4,6.928c-.276,.479-.112,1.09,.366,1.366l-2.5,4.33c-.276,.478-.112,1.089,.366,1.366l-1.5,2.599c-.133,.229-.168,.503-.1,.759,.068,.256,.236,.475,.466,.607l3.465,2c.157,.091,.329,.134,.499,.134,.346,0,.682-.179,.867-.5l1.5-2.598c.153,.088,.326,.133,.499,.133,.087,0,.174-.011,.259-.034,.256-.068,.475-.236,.607-.466l2.5-4.33h0c.153,.088,.326,.134,.5,.134,.087,0,.174-.011,.259-.034,.256-.068,.475-.236,.607-.466l4-6.928c.276-.479,.112-1.09-.366-1.366l-.857-.495,10.893-18.443v18.34h-1c-.553,0-1,.448-1,1v8c0,.552,.447,1,1,1v5c0,.552,.447,1,1,1v3c0,.552,.447,1,1,1h4c.553,0,1-.448,1-1v-3c.553,0,1-.448,1-1v-5c.553,0,1-.448,1-1v-8c0-.552-.447-1-1-1h-1V25.66l10.893,18.443-.857,.495c-.479,.276-.643,.888-.366,1.366l4,6.928c.133,.229,.352,.397,.607,.466,.085,.023,.172,.034,.259,.034,.174,0,.347-.045,.5-.134h0l2.5,4.33c.133,.229,.352,.397,.607,.466,.085,.023,.172,.034,.259,.034,.174,0,.346-.045,.499-.133l1.5,2.598c.186,.321,.521,.5,.867,.5,.17,0,.342-.043,.499-.134l3.465-2c.229-.133,.397-.351,.466-.607,.068-.256,.033-.529-.1-.759ZM6.618,22.691l-.367-1.101,11.131-4.281,.367,1.101-11.131,4.281ZM26,14h12v4h-12v-4ZM7.366,58.687l-1.732-1,1-1.732,1.732,1-1,1.732Zm4.865-6.429l-2,3.463-1.732-1-1.731-1,2-3.464,1.732,1,1.731,1Zm1.866-1.232l-5.195-3,3-5.196,.864,.499h.001l1.732,1.001,2.598,1.5-3,5.196Zm2.277-7.923l-1.748-1.009s12.358-21.926,12.358-22.094h2.015v1.726l-12.625,21.377Zm12.625,2.897h6v6h-6v-6Zm4,16h-2v-2h2v2Zm1-4h-4v-4h4v4Zm-3-14V20h2v24h-2Zm4-22.274v-1.726h2.015c0,.168,12.358,22.094,12.358,22.094l-1.748,1.009-12.625-21.377Zm11.902,24.104l2.598-1.5,1.732-1h.001l.864-.5,3,5.196-5.195,3-3-5.196Zm4.866,6.428l1.731-1,1.732-1,2,3.464-1.731,1-1.732,1-2-3.463Zm4.865,6.429l-1-1.732,1.732-1,1,1.732-1.732,1Z" />
          </g>
        </g>
        <g id="m" />
        <g id="n" />
        <g id="o" />
        <g id="p" />
        <g id="q" />
        <g id="r" />
        <g id="s" />
        <g id="t" />
        <g id="u" />
        <g id="v" />
        <g id="w" />
        <g id="x" />
        <g id="y" />
        <g id="a`" />
        <g id="aa" />
        <g id="ab" />
        <g id="ac" />
        <g id="ad" />
      </svg>
    </>
  );
}
